import { useEffect, useRef } from "react"
import config from "../../config"

export const fbq = (...props: any[]) => {
  try {
    //@ts-ignore
    if (typeof window !== "undefined" && window.fbq) {
      //@ts-ignore
      window.fbq(...props)
    }
  } catch (e) {
    console.error(e)
  }
}

export const fbqPageView = () => {
  fbq("track", "PageView")
}

export const fbqProductView = (product: {
  product_name: string
  content_category: string
  content_ids: number[]
  value: number
}) => {
  fbq("track", "ViewContent", {
    ...product,
    content_type: "product",
    currency: "USD",
  })
}

export const fbqAddToCart = (product: {
  product_name: string
  content_category: string
  content_ids: number[]
  value: number
}) => {
  fbq("track", "AddToCart", {
    ...product,
    content_type: "product",
    currency: "USD",
  })
}

export const fbqSignUp = () => {
  fbq("track", "CompleteRegistration")
}

export const fbqStartCheckout = () => {
  fbq("track", "InitiateCheckout")
}

export const fbqSearch = (query: string) => {
  fbq("track", "Search", {
    search_string: query,
  })
}

const initFacebookPixel = (pixelId: string) => {
  ;(function (f: any, b: Document, e: string, v: string) {
    let n: any, t: any, s: any
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = "2.0"
    n.queue = []
    t = b.createElement(e)
    t.async = !0
    t.src = v
    s = b.getElementsByTagName(e)[0]
    s.parentNode.insertBefore(t, s)
  })(
    window,
    document,
    "script",
    "https://connect.facebook.net/en_US/fbevents.js"
  )
  fbq("init", pixelId)
  fbqPageView()
}

export default function FacebookPixelLoader({ location }) {
  const initedPath = useRef<string | null>(null)

  useEffect(() => {
    if (process.env.NODE_ENV !== "production" || !config.GATSBY_FB_PIXEL_ID)
      return
    if (initedPath.current === null) {
      initFacebookPixel(config.GATSBY_FB_PIXEL_ID)
      initedPath.current = location.pathname
    } else if (initedPath.current !== location.pathname) {
      initedPath.current = location.pathname
      fbqPageView()
    }
  }, [location.pathname])

  return null
}
